<template>
  <!-- 框架右侧top菜单行 -->
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="appStore.sidebar.opened" class="hamburger-container"
      @toggleClick="toggleSideBar" />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" v-if="!settingsStore.topNav" />
    <top-nav id="topmenu-container" class="topmenu-container" v-if="settingsStore.topNav" />

    <div class="right-menu">
      <template v-if="appStore.device !== 'mobile'">
        <span style="display:inline-block;padding-right: 10px;">{{ state.dateTime }}</span>
        <span style="padding-right: 0px;">{{ state.user.userName }}</span>
        <i18nSetting ref="i18nSettingRef"></i18nSetting>
        <header-search id="header-search" class="right-menu-item" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <!-- <el-tooltip content="布局大小" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>
      <div class="avatar-container">
        <el-dropdown @command="handleCommand" class="right-menu-item hover-effect" trigger="click">
          <div class="avatar-wrapper">
            <img :src="userStore.avatar" class="user-avatar" />
            <el-icon><caret-bottom /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <router-link to="/user/profile">
                <el-dropdown-item>{{ $i18nConfig("个人中心") }}</el-dropdown-item>
              </router-link>
              <el-dropdown-item command="setLayout">
                <span>{{ $i18nConfig("布局设置") }}</span>
              </el-dropdown-item>
              <el-dropdown-item divided command="logout">
                <span>{{ $i18nConfig("退出登录") }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script setup>
import { expireAppList } from "@/api/system/company";
import { listDevice } from "@/api/kl/device";
import i18nSetting from './i18n-setting.vue'
import { dayjs, ElMessageBox } from 'element-plus'
import Breadcrumb from '@/components/Breadcrumb'
import TopNav from '@/components/TopNav'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import HeaderSearch from '@/components/HeaderSearch'
import RuoYiGit from '@/components/RuoYi/Git'
import RuoYiDoc from '@/components/RuoYi/Doc'
import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'
import useSettingsStore from '@/store/modules/settings'
import { getUserProfile } from "@/api/system/user";
import { getCurrentInstance } from "vue";
import { ElNotification } from 'element-plus'
import { useRouter } from "vue-router";
const { proxy } = getCurrentInstance();
const appStore = useAppStore()
const userStore = useUserStore()
const settingsStore = useSettingsStore()
const router = useRouter();
const i18nSettingRef = ref();
const state = reactive({
  dateTime: "",
  timer2: null, // 时间定时器
  user: {},
});

function getUser() {
  getUserProfile().then(response => {
    state.user = response.data;
  });
};

getUser();

function toggleSideBar() {
  appStore.toggleSideBar()
}

function handleCommand(command) {
  switch (command) {
    case "setLayout":
      setLayout();
      break;
    case "logout":
      logout();
      break;
    default:
      break;
  }
}

function logout() {
  ElMessageBox.confirm(proxy.$i18nConfig('确定注销并退出系统吗？'), proxy.$i18nConfig('提示'), {
    confirmButtonText: proxy.$i18nConfig('确定'),
    cancelButtonText: proxy.$i18nConfig('取消'),
    type: 'warning'
  }).then(() => {
    userStore.logOut().then(() => {
      window.location.href = import.meta.env.BASE_URL + '/login?t=' + Date.now();
    })
  }).catch(() => { });
}

const emits = defineEmits(['setLayout'])
function setLayout() {
  emits('setLayout');
}

async function equipmentNotice() {
  
  const res = await listDevice({
    endExpireDate: dayjs().subtract(5, 'day').format("YYYY-MM-DD")
  });
  if (res?.code == 200 && res.rows.length > 0) {
    ElNotification({
      type: "warning",
      title: '设备服务到期提醒',
      dangerouslyUseHTMLString: true,
      message: `<div style="cursor: pointer;">
                  <div>您有${res.rows.length}台设备即将过期或已过期,请点击【企业设备】菜单尽快续费,否则会导致无法查询已过期设备数据</div>
                  <div style="color:#008ecf;">点击续费</div>
                </div>
                `,
      duration: 0,
      onClick: () => {
        router.push({
          path: "/baseSetting/device"
        })
      }
    });
  }
}

async function expireAppNotice(){
  const res = await expireAppList({
    endAppValidity: dayjs().subtract(5, 'day').format("YYYY-MM-DD")
  });
  if (res?.code == 200 && res.data.length > 0) {
    let title = "";
    res.data.forEach((item, index) => {
      title = title + item.appName;
      if(index < res.data.length - 1){
        title = title + "<br/>";
      }
    })
    ElNotification({
      type: "warning",
      title: '应用服务到期提醒',
      dangerouslyUseHTMLString: true,
      message: `<div style="cursor: pointer;">
                  <div>您订购的${title}应用服务即将过期或已过期,请点击【工作台/应用市场】菜单尽快续费,否则会导致订购应用无法使用</div>
                  <div style="color:#008ecf;">点击续费</div>
                </div>
                `,
      duration: 0,
      onClick: () => {
        router.push({
          path: "/app-market"
        })
      }
    });
  }
}

function timeFormate(timeStamp) {
  let year = new Date(timeStamp).getFullYear()
  let month = new Date(timeStamp).getMonth() + 1 < 10 ? '0' + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1
  let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
  let hh = new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours()
  let mm = new Date(timeStamp).getMinutes() < 10 ? '0' + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes()
  let ss = new Date(timeStamp).getSeconds() < 10 ? '0' + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds()
  return year + '-' + month + '-' + date + ' ' + hh + ':' + mm + ':' + ss
}

onMounted(() => {
  //定时更新时间
  if (state.timer2) {
    clearInterval(state.timer2);
  } else {
    state.timer2 = setInterval(() => {
      let _dateTime = new Date();
      state.dateTime = timeFormate(_dateTime);
    }, 1000)
  }

  const today = dayjs().format("YYYY-MM-DD");
  const noticeDate = localStorage.getItem("noticeDate");
  if(today != noticeDate){
    equipmentNotice();
    expireAppNotice();
    localStorage.setItem("noticeDate", today);
  }
})

onUnmounted(() => {
  clearInterval(state.timer2);
})
</script>

<style lang='scss' scoped>
::v-deep(.el-menu-item) {
  height: 50px;
  line-height: 40px;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .topmenu-container {
    position: absolute;
    left: 50px;
    width: calc(100% - 580px);
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 20px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        i {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
